import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CategoryCount } from '../types';
import { fetchCategories } from '../utils/api';
import { slugifyCategory, getCategoryIcon } from '../utils/constants';
import './CategoryBubbles.css';

/** Secondary nav aid — renders nothing on empty/failed fetch since the
 *  Navbar/Products page stay reachable regardless. */
const CategoryBubbles: React.FC = () => {
  const [categories, setCategories] = useState<CategoryCount[]>([]);

  useEffect(() => {
    fetchCategories()
      .then(data => setCategories(data.categories ?? []))
      .catch(() => setCategories([]));
  }, []);

  if (categories.length === 0) return null;

  return (
    <section className="bubbles-section">
      <div className="container">
        <div className="bubbles-track">
          {categories.map(cat => (
            <Link key={cat.category} to={`/products/${slugifyCategory(cat.category)}`} className="bubble">
              <span className="bubble-icon"><i className={`fa-solid ${getCategoryIcon(cat.category)}`} aria-hidden="true" /></span>
              <span className="bubble-name">{cat.category}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryBubbles;
